import * as React from 'react';
import * as uuid from 'uuid';
import { observer } from 'mobx-react';

import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { TabLanguageInlineView } from 'src/core/ui/language/tab-language-inline.view';
import { TextView } from 'src/core/ui/text.view';

interface Props extends ComponentViewProps<DataSet<TaxonomyTagItem>> {
	type: 'number' | 'text';
	mode: ControlMode;
	defaultLanguage: string;
}

@observer
export class TaxonomyTags extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	private renderTagAsText = (record: TaxonomyTagItem) => {
		const { mode, setBusy } = this.props;
		const translations = [
			{
				title: 'Name',
				dynamicProperties: record.displayName,
				required: true
			}
		];

		return (
			<TabLanguageInlineView
				dynamicProperties={translations}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	};

	private renderTagAsNumber = (record: TaxonomyTagItem) => {
		const { mode, defaultLanguage } = this.props;
		return (
			<TextView
				required
				label={null}
				mode={mode}
				validate={value => value === '' || /^\d+([.]\d*)?$/.test(value)}
				value={record.displayName[defaultLanguage]}
				onChanged={(newValue) => {
					if (newValue != null) {
						record.displayName[defaultLanguage] = newValue;
					}
				}}
			/>
		);
	};

	handleCreateNewItem = (): Promise<TaxonomyTagItem> => {
		const { model, defaultLanguage } = this.props;
		return model.create(() => ({
			id: uuid.v4(),
			displayName: { [defaultLanguage]: '' }
		}));
	};

	handleValidate = async (item: TaxonomyTagItem): Promise<string[]> => {
		const { defaultLanguage } = this.props;

		if (item.displayName[defaultLanguage] == null || item.displayName[defaultLanguage].trim() === '') {
			return ['The value can not be empty.'];
		}

		return [];
	};

	render(): React.ReactNode {
		const { mode, model, type, defaultLanguage, setBusy } = this.props;
		const columns = [
			{
				title: 'Tag',
				key: 'displayName',
				dataIndex: 'displayName',
				editable: (value: { [lang: string]: string }, record: TaxonomyTagItem, index: number, isSelected: boolean) => {
					if (isSelected) {
						if (type === 'number') {
							return this.renderTagAsNumber(record);
						} else {
							return this.renderTagAsText(record);
						}
					} else if (value == null) {
						return null;
					}

					return value[defaultLanguage] || "";
				}
			}
		];

		return (
			<DataTableView
				model={model}
				columns={columns}
				createNewItem={this.handleCreateNewItem}
				mode={mode}
				isValidItem={this.handleValidate}
				setBusy={setBusy}
				hideToolbar={ToolbarVisibility.hideSearch}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/form/parts/taxonomy-tags.tsx